
import Vue from "vue";
export default Vue.extend({
  name: "hazrat-masoomeh-features",

  data() {
    return {
      features: [
        {
          name: "زیارت نیابتی حرم حضرت معصومه (سلام الله علیها)",
          desc: "ما نایب الزیاره شما هستیم",
          image: require("@/assets/img/hazratMasoomeDetails.png"),
        },
      ],
    };
  },
  methods: {
    handelGoRegister() {
      this.$router.push({
        name: "ziarat-register",
      });
    },
  },

  components: {},
});
